<div class="no-connection">
  <div class="container">
    <div class="image-container">
      <img [src]="'assets/images/not-found/404.svg'" />
    </div>
    <div class="no-connection-text">
      <h2>{{ 'network_error_screen_title' | translate }}</h2>
      <h4>{{ 'network_error_screen_header' | translate }}</h4>
      <h5>{{ 'network_error_screen_description' | translate }}</h5>
    </div>
    <div class="action">
      <app-button
        [btnLabel]="'common_try_again_button_label' | translate"
        [btnClasses]="'btn-small c-generic-white bg-primary-500'"
        [id]="'common_try_again_button_label'"
        [isLoading]="isLoading"
        [disabled]="isLoading"
        (click)="checkNetworkStatus()"></app-button>
    </div>
  </div>
</div>
